var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-51") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N\\xE1vrh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "servantes_Columbo-1",
    transform: "translate(-442.000000, -2018.000000)",
    fill: "#4899C7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-51",
    transform: "translate(442.000000, 2018.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2083333,46 L4.79166667,46 C2.1505,46 0,43.8495 0,41.2083333 L0,8.625 C0,5.98383333 2.1505,3.83333333 4.79166667,3.83333333 L41.2083333,3.83333333 C43.8495,3.83333333 46,5.98383333 46,8.625 L46,41.2083333 C46,43.8495 43.8495,46 41.2083333,46 Z M4.79166667,5.75 C3.20658333,5.75 1.91666667,7.03991667 1.91666667,8.625 L1.91666667,41.2083333 C1.91666667,42.7934167 3.20658333,44.0833333 4.79166667,44.0833333 L41.2083333,44.0833333 C42.7934167,44.0833333 44.0833333,42.7934167 44.0833333,41.2083333 L44.0833333,8.625 C44.0833333,7.03991667 42.7934167,5.75 41.2083333,5.75 L4.79166667,5.75 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0416667,17.25 L0.958333333,17.25 C0.429333333,17.25 0,16.8206667 0,16.2916667 C0,15.7626667 0.429333333,15.3333333 0.958333333,15.3333333 L45.0416667,15.3333333 C45.5706667,15.3333333 46,15.7626667 46,16.2916667 C46,16.8206667 45.5706667,17.25 45.0416667,17.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0833333,37.375 C21.0603333,37.375 21.03925,37.375 21.0143333,37.3730833 C20.7364167,37.3539167 20.4834167,37.214 20.3166667,36.9916667 L14.5666667,29.325 C14.2485,28.9014167 14.33475,28.3015 14.7583333,27.9833333 C15.1819167,27.6651667 15.7818333,27.7495 16.1,28.175 L21.1868333,34.9580833 L31.9048333,24.2400833 C32.2785833,23.8663333 32.8861667,23.8663333 33.2599167,24.2400833 C33.6336667,24.6138333 33.6336667,25.2214167 33.2599167,25.5951667 L21.7599167,37.0951667 C21.57975,37.2753333 21.3363333,37.375 21.0833333,37.375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5416667,9.58333333 C10.0126667,9.58333333 9.58333333,9.154 9.58333333,8.625 L9.58333333,0.958333333 C9.58333333,0.429333333 10.0126667,0 10.5416667,0 C11.0706667,0 11.5,0.429333333 11.5,0.958333333 L11.5,8.625 C11.5,9.154 11.0706667,9.58333333 10.5416667,9.58333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4583333,9.58333333 C34.9293333,9.58333333 34.5,9.154 34.5,8.625 L34.5,0.958333333 C34.5,0.429333333 34.9293333,0 35.4583333,0 C35.9873333,0 36.4166667,0.429333333 36.4166667,0.958333333 L36.4166667,8.625 C36.4166667,9.154 35.9873333,9.58333333 35.4583333,9.58333333 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.62e51642c9447cf89fa90521f8ccaf6c.svg";
export { ForwardRef as ReactComponent };